import { render, staticRenderFns } from "./InputTagDropdownMoment.vue?vue&type=template&id=ab37c510&scoped=true"
import script from "./InputTagDropdownMoment.vue?vue&type=script&lang=js"
export * from "./InputTagDropdownMoment.vue?vue&type=script&lang=js"
import style0 from "./InputTagDropdownMoment.vue?vue&type=style&index=0&id=ab37c510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab37c510",
  null
  
)

export default component.exports